import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"; // استيراد useNavigate
import { apiUrl } from "../../../apiConfig";
import "./AdminSignIn.css";

const AUTH_EVENT = "ihcc-auth-change";

export default function AdminSignIn() {
  const [isReady, setIsReady] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [remember, setRemember] = useState(true);
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const navigate = useNavigate(); // استخدام useNavigate

  useEffect(() => {
    const t = setTimeout(() => setIsReady(true), 30);
    return () => clearTimeout(t);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!email || !password) {
      setError("Please enter your email and password.");
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch(apiUrl("/login.php"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ email, password, remember }),
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(data.message || "Invalid email or password.");
      }

      // حفظ التوكن في التخزين المناسب
      const storage = remember ? localStorage : sessionStorage;
      storage.setItem("ihcc-admin-token", data.token);
      storage.setItem("ihcc-admin-user", JSON.stringify({ email, remember }));

      // إرسال حدث لتحديث كل المكونات
      window.dispatchEvent(new Event(AUTH_EVENT));

      // ✅ التوجيه باستخدام React Router (بدون إعادة تحميل)
      navigate("/admin");

    } catch (err) {
      setError(err.message || "Invalid email or password.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={`admin-signin ${isReady ? "admin-signin--ready" : ""}`}>
      <span className="admin-signin__accent" aria-hidden="true" />
      <span className="admin-signin__accent admin-signin__accent--secondary" aria-hidden="true" />
      <span className="admin-signin__frame" aria-hidden="true" />
      
      <div className="admin-signin__card">
      

        <p className="admin-signin__eyebrow">Admin Access</p>
        <h1 className="admin-signin__title">Sign In</h1>
        <p className="admin-signin__subtitle">
          Sign in to manage job postings and other admin tools.
        </p>

        <form className="admin-signin-form" onSubmit={handleSubmit}>
          {error && (
            <div className="admin-signin-form__error" role="alert">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <circle cx="12" cy="12" r="10" />
                <path d="M12 8v5" />
                <path d="M12 16h.01" />
              </svg>
              <span>{error}</span>
            </div>
          )}

          <div className="admin-signin-form__field">
            <label htmlFor="admin-email">Email Address</label>
            <div className="admin-signin-form__input-wrap">
              <svg className="leading-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <rect x="2" y="4" width="20" height="16" rx="2" />
                <path d="m22 6-10 7L2 6" />
              </svg>
             <input
                id="admin-email"
                type="email"
                autoComplete="username"
                required
                placeholder="your@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>

          <div className="admin-signin-form__field">
            <label htmlFor="admin-password">Password</label>
            <div className="admin-signin-form__input-wrap">
              <svg className="leading-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <rect x="3" y="11" width="18" height="10" rx="2" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              </svg>
             <input
                id="admin-password"
                type={showPassword ? "text" : "password"}
                autoComplete="current-password"
                required
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                className="admin-signin-form__toggle"
                aria-label={showPassword ? "Hide password" : "Show password"}
                onClick={() => setShowPassword((v) => !v)}
              >
                {showPassword ? (
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 10 8 10 8a17.4 17.4 0 0 1-2.16 3.19" />
                    <path d="M6.6 6.6C3.4 8.4 2 12 2 12s3 8 10 8a9.14 9.14 0 0 0 5.4-1.6" />
                    <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
                    <path d="M2 2l20 20" />
                  </svg>
                ) : (
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M2 12s3-8 10-8 10 8 10 8-3 8-10 8-10-8-10-8Z" />
                    <circle cx="12" cy="12" r="3.4" />
                  </svg>
                )}
              </button>
            </div>
          </div>

          <div className="admin-signin-form__row">
            <label className="admin-signin-form__remember">
              <input
                type="checkbox"
                checked={remember}
                onChange={(e) => setRemember(e.target.checked)}
              />
              Remember me
            </label>
          
          </div>

          <button
            type="submit"
            className="btn btn-accent admin-signin-form__submit"
            disabled={isSubmitting}
          >
            {isSubmitting && <span className="admin-signin-form__spinner" aria-hidden="true" />}
            {isSubmitting ? "Signing In..." : "Sign In"}
          </button>
        </form>

        <a href="/" className="admin-signin__back">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M19 12H5" />
            <path d="m12 19-7-7 7-7" />
          </svg>
          Back to Website
        </a>
      </div>
    </div>
  );
}